module.exports = "/build/web/images/hero-home.23ced8fd332a30a8d7fd1b69199ecff8.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero-home.jpg
// module id = 122
// module chunks = 11